import { Component } from '@theme/component';

/**
 * Autoplay story videos with click/keyboard toggle (ODB-45). Respects `prefers-reduced-motion`.
 *
 * @extends {Component<{}>}
 */
class FiftyFiftyStory extends Component {
  /** @type {AbortController | undefined} */
  #videoBindings;

  connectedCallback() {
    super.connectedCallback();
    this.#bindVideos();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#videoBindings?.abort();
    this.#videoBindings = undefined;
  }

  #bindVideos() {
    this.#videoBindings?.abort();
    this.#videoBindings = new AbortController();
    const { signal } = this.#videoBindings;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const playLabel = this.dataset.playLabel || 'Play video';
    const pauseLabel = this.dataset.pauseLabel || 'Pause video';

    for (const slot of this.querySelectorAll('.section-50-50-story__video-slot')) {
      if (!(slot instanceof HTMLElement)) continue;
      const video = slot.querySelector('.section-50-50-story__video');
      const control = slot.querySelector('.section-50-50-story__video-control');
      if (!(video instanceof HTMLVideoElement) || !(control instanceof HTMLButtonElement)) continue;

      const setControlState = () => {
        const isPaused = video.paused;
        control.dataset.state = isPaused ? 'paused' : 'playing';
        control.setAttribute('aria-label', isPaused ? playLabel : pauseLabel);
        control.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      };

      const togglePlayback = () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      if (reducedMotion) {
        video.pause();
      }

      setControlState();
      control.addEventListener('click', togglePlayback, { signal });
      video.addEventListener('click', togglePlayback, { signal });
      video.addEventListener('play', setControlState, { signal });
      video.addEventListener('pause', setControlState, { signal });
    }
  }
}

if (!customElements.get('fifty-fifty-story')) {
  customElements.define('fifty-fifty-story', FiftyFiftyStory);
}
